import { createApp } from 'vue'
import ChatwallViewer from './ChatwallViewer.vue'

createApp(ChatwallViewer).mount('#app-chatwall-viewer')
